
export default class PageResizeService {
    init() {
        this.updateCssVariable()
        window.addEventListener('resize', () => this.onResize())
    }

    dispose() {
        console.log("dispose")
        window.removeEventListener('resize', () => this.onResize())
    }

    private onResize() {
        setTimeout(() => {
            this.updateCssVariable()
        }, 200)
        setTimeout(() => {
            this.updateCssVariable()
        }, 500)
    }

    private updateCssVariable() {
        const val = `${window.innerHeight / 100}px`
        console.log("update --vh " + val)
        document.documentElement.style.setProperty('--vh', val)
    }
}